import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTaskList = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4 17.575 1.455 1.455 2.424-2.425M4 11.759l1.455 1.454 2.424-2.424M4 5.938l1.455 1.455 2.424-2.424M11.273 18.059h8.728M11.273 12.242h8.728M11.273 6.422h8.728"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTaskList);
export default ForwardRef;
